import { useQueryLoginUserContext } from 'src/features/tanStackQuery/commonQueries/useQueryLoginUserContext'

export const useIsLobsterEnabled = () => {
  const { data: loginUserContext } = useQueryLoginUserContext()

  return { isLobsterEnabled: loginUserContext?.isLobsterEnabled ?? false }
}
